import { Config } from "@apis/index";
import { RootState } from "@store/index";
import React, { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";

const useConfig = () => {
  const { data: config } = useSelector((state: RootState) => state.config);

  const fetchConfig = useCallback(async () => {
    await Config.list({ state: "config" });
  }, []);
  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);
  return {
    bucketUrl: config?.bucketUrl,
    lensAddonTypes: config?.lensAddonTypes,
  };
};

export default useConfig;
